import { Box, Typography, InputBase, Button, Modal, Checkbox, Tooltip, InputAdornment, IconButton, TextField } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { Campaign_table } from "../../sub_components/campaign_table";
import { useDispatch, useSelector } from "react-redux";
import { updateModal, updateEdit, updateCampaignDetails, updateSearchCampaign } from "../../Redux/campaign";
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { Editor } from "primereact/editor";
import { act, useEffect, useState } from "react";
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import AddIcon from '@mui/icons-material/Add';
import { OrderModal, OrderModalDelivery } from "../globalFunctions";
import { useGetCampaign } from '../globalFunctions';
import CustomAxios from "../../utils/CustomAxios";
import { ToastContainer, toast } from 'react-toastify';
import { LocalizationProvider , DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import * as Yup from "yup";
import dayjs from "dayjs";
import { Toast } from 'primereact/toast';
import { useRef } from "react";
import 'react-toastify/dist/ReactToastify.css';
import CircularProgress from '@mui/material/CircularProgress';
import axios from "axios";



export function Campaign(){

    const dispatch = useDispatch()

    const campaignModal = useSelector(state => state.campaign.modal)
    const campaignEdit = useSelector(state => state.campaign.campaignEdit)
    const [formData, setFormData] = useState({});
    const getCampaign = useGetCampaign();
    const authToken = localStorage.getItem('authtoken');
    const campaign = useSelector(state => state.campaign.campaign);
    const activeCampaign = useSelector(state => state.campaign.activeStatus);
    const upcomingCampaign = useSelector(state => state.campaign.upcomingCampaign);
    const expiredCampaign = useSelector(state => state.campaign.expiredCampaign);
    const edit = useSelector(state => state.campaign.edit)
    const [imagePreviews, setImagePreviews] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false)
    const toast = useRef(null);
    const products = useSelector(state => state.products.products);
    const campaignDetails = useSelector(state => state.campaign.campaignDetails);
    const inventory = useSelector(state => state.inventory.inventory)
    const hub = useSelector(state => state.user.selected_hub);
    const selectedHub = useSelector(state => state.user.selected_hub); // gets ID
    const user_role = localStorage.getItem('role');
    
    // Get assigned hubs for Customer Engagement Admin
    const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
    
    // Build inventory options: show all, but disable unassigned for restricted roles
    const filteredInventory = (inventory || []).map((inv) => {
        const isAssigned = assignedHubs.includes(inv.value);
        return {
            ...inv,
            name: inv.name ?? 'Not assigned hub',
            disabled: ['admin', 'supervisor', 'customer_engagement_admin'].includes(user_role) ? !isAssigned : false
        };
    });
    
    // Filter campaigns based on user role and assigned hubs
    const filteredCampaigns = user_role === 'customer_engagement_admin' 
        ? campaign.filter(camp => {
            // Check if campaign has any inventory that matches assigned hubs
            return camp.inventory && camp.inventory.some(inv => assignedHubs.includes(inv.id));
        })
        : campaign;
    
    const filteredActiveCampaign = user_role === 'customer_engagement_admin'
        ? activeCampaign.filter(camp => {
            return camp.inventory && camp.inventory.some(inv => assignedHubs.includes(inv.id));
        })
        : activeCampaign;
        
    const filteredUpcomingCampaign = user_role === 'customer_engagement_admin'
        ? upcomingCampaign.filter(camp => {
            return camp.inventory && camp.inventory.some(inv => assignedHubs.includes(inv.id));
        })
        : upcomingCampaign;
        
    const filteredExpiredCampaign = user_role === 'customer_engagement_admin'
        ? expiredCampaign.filter(camp => {
            return camp.inventory && camp.inventory.some(inv => assignedHubs.includes(inv.id));
        })
        : expiredCampaign;

    const status = [
        { name: 'Active', value: 'active' },
        { name: 'Inactive', value: 'inactive' },
    ];

    const pages = [
        { name: 'Wallet', value: 'WalletPage' },
        { name: 'profile', value: 'ProfilePage' },
    ];

    useEffect(() => {
        getCampaign()
    }, [authToken])

    useEffect(() => {
        // if (campaignDetails && Object.keys(campaignDetails).length > 0) {
            setFormData({
                ...campaignDetails,
                launch_date: campaignDetails.launch_date ? dayjs(campaignDetails.launch_date) : null,
                end_date: campaignDetails.end_date ? dayjs(campaignDetails.end_date) : null,
            });
        // }
    }, [campaignDetails]);

    useEffect(() => {
        if (edit) {
            console.log("FOrm",formData)
            console.log("-------------->", campaignDetails?.campaign_image_urls)
            setImagePreviews(campaignDetails?.campaign_image_urls)
            const convert = async () => {
                const fetchedImages = await Promise.all(
                    campaignDetails?.campaign_image_urls?.map(async (url) => {
                        //console.log(url)
                        const response = await fetch(url);
                        //console.log(response)
                        const blob = await response.blob();
                        const file = url.split('/').pop();
                        //console.log(file)
                        return new File([blob], file, { type: "image/jpeg" });
                    })
                );
                console.log("ftttt",fetchedImages)  
                console.log("FOrm1",formData)
                setFormData(prevData => ({
                    ...prevData,
                    campaign_images: fetchedImages,
                    launch_date: campaignDetails.launch_date ? dayjs(campaignDetails.launch_date) : null,
                    end_date: campaignDetails.end_date ? dayjs(campaignDetails.end_date) : null,
                }));
            };

            convert();

            // console.log("FOrm2",formData)
            // setFormData(prevData => ({
            //     ...prevData,
            //     ...campaignDetails,
            //     launch_date: campaignDetails.launch_date ? dayjs(campaignDetails.launch_date) : null,
            //     end_date: campaignDetails.end_date ? dayjs(campaignDetails.end_date) : null,
            // }));
        }
    }, [edit])    

   

    // Check if user can manage campaigns (create, edit, delete) - AFTER all hooks
    const canManageCampaigns = ['super_admin', 'admin', 'supervisor','merchant'].includes(user_role);
    const canViewCampaigns = ['super_admin', 'admin', 'supervisor', 'customer_engagement_admin','merchant'].includes(user_role);

    if (!canViewCampaigns) {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", padding: "20px" }}>
                <Typography variant="h6" color="error">
                    Access Denied
                </Typography>
                <Typography>
                    You don't have permission to access campaigns.
                </Typography>
            </Box>
        );
    }

    const handleOpen = () => {
        setErrors({})
        dispatch(updateCampaignDetails({
            inventory: user_role==="supervisor"?selectedHub:formData.inventory,
            description: "",
            launch_date: null,
            end_date: null,
            status: "",
            campaign_images: []
        }))
        dispatch(updateEdit(false));
        dispatch(updateModal(true))
    };

    const handleCloseCampaignModal = () => {
        setErrors({})
        dispatch(updateModal(false)); 
        dispatch(updateEdit(false))
        dispatch(updateCampaignDetails({
            inventory: [],
            description: "",
            launch_date: null,
            end_date: null,
            status: "",
            campaign_images: []
        }))
        setImagePreviews([])
    };

    const handleChange = (e, type) => {
        const {value} = e
        if (type === "launch_date" || type === "end_date") {
            setFormData({
                ...formData,
                [type]: dayjs(e), 
            });
            setErrors((prevErrors) => ({ ...prevErrors, [type]: null }));
        } else if (type === "product") {
            setFormData((prev) => ({
              ...prev,
              navigation: { product: value === null ? null : value }, 
            }));
          } else if (type === "page") {
            setFormData((prev) => ({
              ...prev,
              navigation: { page: value === null ? null : value}, 
            }));
          }
        
        else {
            const { name, value } = e.target;
            setFormData({
                ...formData,
                [name]: value,
            });
            setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
        }
    };
    

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        console.log(files)
        console.log("frmd",formData)
        if (edit) {
            const url = URL.createObjectURL(e.target.files[0]);
            setImagePreviews(prev => ([...prev, url]));
            setFormData({
                ...formData,
                campaign_images: [...formData.campaign_images, e.target.files[0]]
            });
        }else{
            const previews = files?.map((file) => URL.createObjectURL(file));
            console.log("previews", previews)
            setImagePreviews(prev => ([...prev, ...previews]));
            console.log("fffftttt", formData, files)
            setFormData({
                ...formData,
                campaign_images: [...formData.campaign_images, ...files]
            });
        }
        // dispatch(updateProductDetail('images', files));
    };

    const handleRemoveImage = (index) => {
        const newImages = formData?.campaign_images?.filter((_, i) => i !== index);
        //console.log(newImages)
        setFormData((prevData) => ({ ...prevData, campaign_images: newImages??[] }));
        if (!edit) {
            const updatedPreviews = imagePreviews.filter((_, i) => i !== index);
            setImagePreviews(updatedPreviews);
        } else {
            const newImagesurls = formData?.campaign_image_urls?.filter((_, i) => i !== index);
            setFormData((prevData) => ({ ...prevData, campaign_images: newImages??[],campaign_image_urls:newImagesurls }));
            setImagePreviews(imagePreviews?.filter((_, i) => i !== index));
        }

        // dispatch(updateProductDetail('images', formData.images.filter((_, i) => i !== index)));
    };


    const handleSaveCampaigns = async () => {
        const data = new FormData();
    
        for (const [key, value] of Object.entries(formData)) {
            if (key === "launch_date" || key === "end_date") {
                const formattedDate = dayjs(value).format("YYYY-MM-DD");
                data.append(key, formattedDate);
            } else if (Array.isArray(value)) {
                if (key === "campaign_images") {
                    value.forEach((file) => {
                        if (file instanceof File) {
                            data.append(key, file);
                        } else {
                            console.error(`Expected a File object, but received:`, file);
                        }
                    });
                } else if (key === "inventory") {
                    value.forEach((id) => {
                        data.append("inventory_ids", id); // append each number separately under 'inventory'
                    });
                }
            } else if(key === "navigation"){
                data.append("navigation", JSON.stringify(formData.navigation));
            }
            else{
                data.append(key, value);
            }
        }
    
        try {
            await validationSchema.validate(formData, { abortEarly: false });
            setErrors({});
    
            if (data) {
                setLoading(true);
    
                await CustomAxios.post(`campaigns/add/`, data)
                    .then((res) => {
                        toast.current.show({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Campaign Added Successfully',
                            life: 3000,
                        });
                        getCampaign();
                        handleCloseCampaignModal();
                        setFormData({});
                        dispatch(updateModal(false));
                        setLoading(false);
                    })
                    .catch((error) => {
                        // Handle duplicate description error
                        if (
                            error.response &&
                            error.response.data
                        ) {
                            setErrors({ description: "Description already exists" });
                            setLoading(false); // Stop loading on this error
                        } else {
                            console.error("Error while saving campaign:", error);
                            setLoading(false); // Stop loading for other errors
                        }
                    });
            }
        } catch (validationErrors) {
            if (validationErrors.name === "ValidationError") {
                const formErrors = {};
                validationErrors.inner.forEach((error) => {
                    formErrors[error.path] = error.message;
                });
                setErrors(formErrors);
            }
            setLoading(false); // Stop loading on validation error
        }
    };
    

    const handleUpdateCampaigns = async (id) => {
        const data = new FormData();
    
        for (const [key, value] of Object.entries(formData)) {
            if (key === "launch_date" || key === "end_date") {
                const formattedDate = dayjs(value).format("YYYY-MM-DD");
                data.append(key, formattedDate);
            } else if (Array.isArray(value)) {
                if (key === "campaign_images") {
                    value.forEach((file) => {
                        if (file instanceof File) {
                            data.append(key, file);
                        } else {
                            console.error(`Expected a File object, but received:`, file);
                        }
                    });
                } else if (key == "inventory") {
                    value.forEach((id) => {
                        data.append("inventory", id);
                    });
                }
            } else if(key === "navigation"){
                data.append("navigation", JSON.stringify(formData.navigation));
            } else {
                data.append(key, value);
            }
        }
    
        try {
            setLoading(true);
            await validationSchema.validate(formData, { abortEarly: false });
            setErrors({});
    
            await CustomAxios.put(`campaigns/update/${id}/`, data)
                .then((res) => {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Campaigns updated successfully',
                        life: 3000,
                    });
                    getCampaign();
                    handleCloseCampaignModal();
                    setFormData([]);
                    dispatch(updateModal(false));
                    setLoading(false);
                });
        } catch (error) {
            if (error.name === "ValidationError") {
                const formErrors = {};
                error.inner.forEach((err) => {
                    formErrors[err.path] = err.message;
                });
                setErrors(formErrors);
                setLoading(false);
            } 
            // Handle duplicate description error from the backend
            else if (
                error.response &&
                error.response.data
            ) {
                setErrors({ description: "Description already exists" });
                setLoading(false); // Ensure loading is stopped for this error
            } else {
                console.error("Error while updating campaign:", error);
                setLoading(false); // Stop loading on other errors as well
            }
        }
    };
    


    const validationSchema = Yup.object().shape({
        description: Yup.string().required("Description is required"),
        launch_date: Yup.date().required("Launch date is required"),
        end_date: Yup.date()
            .required("End date is required")
            .min(Yup.ref('launch_date'), "End date must be after the launch date"),
        status: Yup.string().required("Status is required"),
        campaign_images: Yup.array()
        .of(
            Yup.mixed().test("file-or-url", "Each item must be a valid file or URL", (value) => {
                return typeof value === "string" || value instanceof File;
            })
        )
        .min(1, "At least one image is required")
            .required("Images are required"),
        inventory: Yup.array()
            .of(Yup.mixed()) // or define the shape of each item if needed
            .min(1, "At least one inventory item is required")
            .required("Inventory list is required")
    });

    const selectedCountryTemplate = (option, props) => {
        if (option) {
            return (
                <Box sx={{ display: "flex", gap: "10px" }}>
                    <Box component="img" alt={option.name} src={option.image} sx={{ width: '16px', height: "16px", objectFit: "cover" }} />
                    <Box>{option.name}</Box>
                </Box>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const countryOptionTemplate = (option) => {
        return (
            <Box sx={{ display: "flex", gap: "10px" }}>
                <Box component="img" alt={option.name} src={option.image} sx={{ width: '30px', height: "30px", objectFit: "cover" }} />
                <Box>{option.name}</Box>
            </Box>
        );
    };
    return(
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%",padding:"30px" }}>
            <Toast ref={toast} />
            <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" transition="Bounce" />
         {/* <ConfirmDialog /> */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>Product Management</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>Campaign</Typography>
        </Box>
      <Box sx={{height:"94px",width:"100%",backgroundColor:"white",display:"flex",alignItems:{sm:"center",md:"center"}}}>
            <Box sx={{width:"100%"}}>
                <Typography sx={{ fontSize: {sm:"24px",md:"24px"}, fontWeight: "500", lineHeight: "32px",textAlign:"center" }}>{filteredCampaigns !== 0 ? filteredCampaigns.length : 0}</Typography>
                <Typography sx={{ fontSize: {sm:"14px",md:"14px"}, fontWeight: "400", lineHeight: "22px",textAlign:"center" }}>Total Campaign</Typography>
            </Box>
            <Box sx={{width:"100%"}}>
                <Typography sx={{ fontSize: {sm:"24px",md:"24px"}, fontWeight: "500", lineHeight: "32px",textAlign:"center" }}>{filteredActiveCampaign !== 0 ? filteredActiveCampaign.length : 0}</Typography>
                <Typography sx={{ fontSize: {sm:"14px",md:"14px"}, fontWeight: "400", lineHeight: "22px",textAlign:"center" }}>Active Campaign</Typography>
            </Box>
            <Box sx={{width:"100%"}} >
                <Typography sx={{ fontSize: {sm:"24px",md:"24px"}, fontWeight: "500", lineHeight: "32px",textAlign:"center" }} >{filteredUpcomingCampaign.length !== 0 ? filteredUpcomingCampaign.length : 0}</Typography>
                <Typography sx={{ fontSize: {sm:"14px",md:"14px"}, fontWeight: "400", lineHeight: "22px",textAlign:"center" }}>Upcoming Campaign</Typography>
            </Box>
            <Box sx={{width:"100%"}}>
                <Typography sx={{ fontSize: {sm:"24px",md:"24px"}, fontWeight: "500", lineHeight: "32px",textAlign:"center" }}>{filteredExpiredCampaign.length !== 0 ? filteredExpiredCampaign.length : 0}</Typography>
                <Typography sx={{ fontSize: {sm:"14px",md:"14px"}, fontWeight: "400", lineHeight: "22px",textAlign:"center" }}>Expired Campaign</Typography>
            </Box>
        </Box>
         <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <Box sx={{ position: "relative" }}>
                <InputBase sx={{ backgroundColor: "white", height: "32px", width: "100%", maxWidth: "268px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px 5px 40px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Search item name" onChange={(e) => dispatch(updateSearchCampaign(e.target.value))} />
                <SearchIcon sx={{ position: "absolute", left: "12px", top: "5px", width: "20px", height: "20px" }} />
            </Box>
            {canManageCampaigns && (
                <Box sx={{ display: "flex", gap: "20px" }}>
                    <Button variant="contained"  sx={{ textTransform: "none" }}> <Typography sx={{fontSize: {sm:"12px",md:"14px"}, fontWeight: "400", lineHeight: "22px",textAlign:"center"}} 
                    onClick={handleOpen}
                    >Add Items</Typography></Button>
                </Box>
            )}
        </Box>
        <Campaign_table />
        {/* <OrderDetailsModal/> */}
        <Modal
                open={campaignModal}
                onClose={handleCloseCampaignModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ zIndex: 1000 }}
            >
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100%', maxWidth: "600px", height: "687px", backgroundColor: 'white', }}>
                    <Box sx={{ height: "46px important", padding: "12px 24px", backgroundColor: "#EEEEEE", display: "flex", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "14", fontWeight: "500", lineHeight: "22px" }}> {campaignEdit ? "Edit Campaign" : "Add Campaign"}</Typography>
                    </Box>
                    <Box >
                        <Box sx={{ padding: "24px", display: "flex", gap: "16px", flexDirection: "column", height: "590px", overflowY: "auto" }}>

                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Inventory List</Typography>
                                <MultiSelect
                                    value={user_role==="supervisor"?selectedHub:formData.inventory}
                                    onChange={handleChange}
                                    options={filteredInventory}
                                    optionValue="value"
                                    optionLabel="name"
                                    optionDisabled="disabled"
                                    name="inventory"
                                    disabled={user_role==="supervisor"?true:false}
                                    placeholder="Select Inventory List"
                                    className="w-full md:w-14rem"
                                    checkmark={true}
                                    highlightOnSelect={false}
                                />
                                {errors.inventory && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.inventory}</Typography>}
                            </Box>

                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Description</Typography>
                                <InputBase 
                                    value={formData.description} 
                                    sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} 
                                    placeholder="Enter Description of Campaign" 
                                    name="description" 
                                    onChange={handleChange} 
                                />
                                {errors.description && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.description}</Typography>}
                            </Box>

                            <Box sx={{ width: "100%", display: "flex", gap: "16px" }}>
                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} name="item_category">Launch Date</Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                value={formData.launch_date || null}
                                                onChange={(e)=>handleChange(e,"launch_date")}
                                                className="pan-datepicker background"
                                                renderInput={(params) => <TextField {...params} sx={{fontSize:"14px",}} placeholder="DD/MM/YY"/>}
                                                name="launch_date"
                                                sx={{
                                                    pading:0,
                                                    "&.pan-datepicker .MuiInputBase-root.MuiOutlinedInput-root": {
                                                        height: '32px',
                                                        padding: '0 8px',
                                                        border: "none",
                                                        width: "100%",
                                                        backgroundColor: "#FFF",
                                                        zIndex: 2
                                                    },
                                                    "&.MuiPaper-root-MuiPickersPopper-paper": {
                                                        backgroundColor: "#FFF"
                                                    },
                                                    "& .MuiPaper-root": {
                                                        backgroundColor: "#FFF", 
                                                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)', 
                                                        borderRadius: '8px', 
                                                    },
                                                }}
                                            />
                                            </LocalizationProvider>
                                {errors.launch_date && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.launch_date}</Typography>}

                                </Box>
                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >End Date</Typography>

                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                value={formData.end_date || null}
                                                onChange={(e)=>handleChange(e,"end_date")}
                                                className="pan-datepicker background"
                                                renderInput={(params) => <TextField {...params} sx={{fontSize:"14px",}} placeholder="DD/MM/YY"/>}
                                                name="end_date"
                                                sx={{
                                                    pading:0,
                                                    "&.pan-datepicker .MuiInputBase-root.MuiOutlinedInput-root": {
                                                        height: '32px',
                                                        padding: '0 8px',
                                                        border: "none",
                                                        width: "100%",
                                                        backgroundColor: "#FFF",
                                                        zIndex: 2
                                                    },
                                                    "&.MuiPaper-root-MuiPickersPopper-paper": {
                                                        backgroundColor: "#FFF"
                                                    },
                                                    "& .MuiPaper-root": {
                                                        backgroundColor: "#FFF", 
                                                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)', 
                                                        borderRadius: '8px', 
                                                    },
                                                }}
                                            />
                                            </LocalizationProvider>
                                {errors.end_date && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.end_date}</Typography>}

                                </Box>
                                {/* <Box sx={{ width: "50%", display: "flex", flexDirection: "row",marginTop:"25px", gap: "10px", alignItems:"center", justifyContent:"center" }}>
                                    <Checkbox onChange={handleChange} checked={formData.bogo===true?true:false} name="bogo"/>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Buy One Get One Free</Typography>
                                    <Dropdown value={formData.item_criteria} onChange={handleChange} options={criteria} optionLabel="name" name="item_criteria"
                                        placeholder="Select criteria" className="w-full md:w-14rem" checkmark={true} highlightOnSelect={false} />
                                    

                                </Box> */}
                            </Box>
                            
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Status</Typography>
                                   <Dropdown 
                                        value={formData.status} 
                                        onChange={handleChange} 
                                        options={status} 
                                        optionLabel="name" 
                                        name="status"
                                        placeholder="Select Status" 
                                        className="w-full md:w-14rem" 
                                        checkmark={true} 
                                        highlightOnSelect={false} 
                                    />
                                {errors.status && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.status}</Typography>}
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "row", gap: "10px" }}>
                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}>
                                    Navigation Related Product
                                    </Typography>
                                    <Dropdown onChange={(e) => handleChange(e, "product")} value={formData.navigation?.product ? formData.navigation.product : null} options={products} name="navigation_product" optionLabel="name" style={{ zIndex: "1000", height: "32px" }} placeholder="Select Product" className="w-full md:w-14rem" valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate} filter filterBy="name" showClear/>
                                </Box>

                                <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}>
                                    Navigation Related Page
                                    </Typography>
                                    <Dropdown onChange={(e) => handleChange(e, "page")} value={formData.navigation?.page ? formData.navigation.page : null} options={pages} name="navigation_page" optionLabel="name" style={{ zIndex: "1000", height: "32px" }} placeholder="Select Page" className="w-full md:w-14rem" filter filterBy="name" showClear/>
                                </Box>
                            </Box>
                        
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px',alignItems:"center" }}>
                                {imagePreviews?.map((image, index) => (
                                    <Box key={index} sx={{ width: '104px', height: '104px', border: '1px solid', borderColor: 'secondary.border', borderRadius: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', cursor: 'pointer', backgroundColor: 'background.upload', overflow: 'hidden', '&:hover .overlay': { display: 'block', }, '&:hover .delete-button': { display: 'flex', }, }}>
                                        <img src={image} alt={`Uploaded ${index}`} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px', transition: 'opacity 0.3s', }} />
                                        <Box className="overlay" sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#00000080', display: 'none', borderRadius: '8px', }} />
                                        <Tooltip title="Delete" arrow>
                                            <IconButton className="delete-button" 
                                                onClick={() => handleRemoveImage(index)} 
                                                sx={{ position: 'absolute', top: "50%", left: "50%", display: 'none', transform: 'translate(-50%, -50%)', }}>
                                                <DeleteOutlineIcon sx={{ color: "white" }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                ))}

                                <Box
                                    sx={{ width: '104px', height: '104px', border: '1px solid', borderColor: 'secondary.border', borderRadius: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', cursor: 'pointer', backgroundColor: 'background.upload', }}>
                                    <input 
                                        type="file" 
                                        accept="image/*" 
                                        id="upload-input" 
                                        style={{ position: 'absolute', width: '104px', height: '104px', opacity: 0, cursor: 'pointer', top: 0, left: 0 }} 
                                        onChange={handleImageChange} 
                                        name="images" 
                                    />
                                    <label htmlFor="upload-input" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <AddIcon fontSize="large" />
                                        <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}>Upload</Typography>
                                    </label>
                                </Box>
                            {errors.campaign_images && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.campaign_images}</Typography>}
                            </Box>

                        </Box>
                    </Box>
                    
                    <Box sx={{ backgroundColor: "#EEEEEE", display: "flex", alignItems: "center", position: "absolute", bottom: 0, display: "flex", justifyContent: "flex-end", width: "100%" }}>
                        <Box sx={{ padding: "12px 24px", display: "flex", gap: "20px" }}>
                            <Button 
                                variant="outlined" 
                                sx={{ textTransform: "none", color: "black", backgroundColor: "white", height: "32px", width: "67px" }} 
                                onClick={handleCloseCampaignModal}
                                > cancel</Button>
                            <Button 
                                variant="contained" 
                                disabled = {loading?true:false}
                                sx={{ textTransform: "none", height: "32px", width: "67px" }} 
                                onClick={() => edit ? handleUpdateCampaigns(campaignDetails.id) : handleSaveCampaigns()}
                            > 
                                {edit ? loading?<CircularProgress size="25px" sx={{color:"white"}}/>:"Update" : loading?<CircularProgress size="25px" sx={{color:"white"}}/>:"Save"}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
            <OrderModal/>
            <OrderModalDelivery/>
    </Box>
    )
}